// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"6f8bb795","893":"3f70c1a2"}[chunkId] + ".chunk.js";
};